import script from "./DeviceDetailsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceDetailsPage.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceDetailsPage.vue?vue&type=style&index=0&id=6ae89729&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae89729"]])

export default __exports__